import { TextItemsFilterComponent } from './TextItemsFilter.component';

export const TextItemsFilter = TextItemsFilterComponent;
